<div class="blog-block-button">
  <a
    [href]="block.url"
    [ngClass]="classes"
    [attr.target]="target"
    [attr.rel]="rel"
  >
    {{ block.label }}
  </a>
</div>
